import { Component, OnInit } from '@angular/core';
import { Empty_Salary_Sanavat_Interface, Salary_Sanavat_Interface } from 'src/app/Interface/Salary_Sanavat_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SalaryService } from 'src/app/Service/Salary/Salary.service';

@Component({
  selector: 'app-SalarySanavatList',
  templateUrl: './SalarySanavatList.component.html',
  styleUrls: ['./SalarySanavatList.component.css']
})
export class SalarySanavatListComponent implements OnInit {
  Filter_title: string = ""
  Filter_year: string = "1405"
  page: number = 0;
  Procssing: boolean = false

  modalRef_Delete: any;

  constructor(
    private Salary_Service: SalaryService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
  ) { }


  DataList_Salary: Array<any> = []


  ngOnInit() {
    this.Nav_Service.CheckValidPage(2234).subscribe(
      data => {
        this.ReadData_Salary()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  ReadData_Salary() {
    this.Procssing = true
    this.Salary_Service.GetSanavat(Number(this.Filter_year)).subscribe(
      data => {
        this.DataList_Salary = data
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_title() {
    this.page = 0
  }

  SubmitAddNewSalary(model: any) {
    var Record: Salary_Sanavat_Interface = Empty_Salary_Sanavat_Interface()
    Record.id =  Number(model.id)
    Record.sanavat = Number(model.sanavat)

    this.Procssing = true
    this.Salary_Service.AddSanavat(Record).subscribe(
      data => {
        this.Procssing = false
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

}
